export default class {
  constructor () {
    this.element = document.querySelector("[data-component='map']")

    if (this.element) {
      this.showMap()
    }
  }

  showMap () {
    const lat = parseFloat(this.element.dataset.lat)
    const lng = parseFloat(this.element.dataset.lng)
    const map = new google.maps.Map(this.element, this.googleOptions(lat, lng))
    const markerIcon = this.element.dataset.markerIcon

    const marker = new google.maps.Marker({
      position: { lat, lng },
      map
    })

    marker.setIcon(markerIcon)
  }

  googleOptions (lat, lng) {
    return {
      mapTypeControl: false,
      streetViewControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
      },
      panControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
      },
      zoom: 16,
      maxZoom: 17,
      minZoom: 5,
      center: { lat, lng },
      styles: [
        {
          'featureType': 'administrative',
          'elementType': 'all',
          'stylers': [ { 'visibility': 'on' } ]
        },
        {
          'featureType': 'administrative',
          'elementType': 'labels.text.fill',
          'stylers': [ { 'color': '#444444' } ]
        },
        {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi.medical",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          'featureType': 'landscape',
          'elementType': 'all',
          'stylers': [
            { 'color': '#f2f2f2' },
            { 'visibility': 'on' }
          ]
        },
        {
          'featureType': 'road.highway',
          'elementType': 'all',
          'stylers': [ { 'visibility': 'simplified' } ]
        },
        {
          'featureType': 'road.arterial',
          'elementType': 'all',
          'stylers': [ { 'visibility': 'on' } ]
        },
        {
          'featureType': 'transit',
          'elementType': 'all',
          'stylers': [ { 'visibility': 'on' } ]
        },
        {
          'featureType': 'water',
          'elementType': 'all',
          'stylers': [
            { 'color': '#b6e1f3' },
            { 'visibility': 'on' }
          ]
        }
      ]
    }
  }
}
